import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  CartItemComponent,
  CartService,
  ProductService,
  PriceService,
  AvailabilityService,
  Availability
} from 'gung-standard';
import { Observable, of, Subject } from 'rxjs';
import { ColmecAddonsCartService, AddOnsByProduct } from './../../../services/colmec-addons-cart.service';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'colmec-cart-item',
    templateUrl: './colmec-cart-item.component.html',
    styleUrls: ['./colmec-cart-item.component.scss'],
    standalone: false
})
export class ColmecCartItemComponent extends CartItemComponent implements OnInit, OnDestroy {
  availability: Availability;
  productAddons: AddOnsByProduct;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public productService: ProductService,
    protected cartService: CartService,
    private colmecAddonsCartService: ColmecAddonsCartService,
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService
  ) {
    super(productService, cartService, priceService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      this.availabilityService
        .getAvailability(this.data.productId, undefined, true)
        .subscribe(availability => (this.availability = availability))
    );

    this.colmecAddonsCartService
      .getAddOnProductsByParentProduct()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(addOnsByProducts => {
        this.productAddons = addOnsByProducts.find(item => item.productId === this.data.productId);
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public trackByAddon(index: number, item: any) {
    return index;
  }
}
